// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  color: #ffffff;
  background: rgba(51, 40, 34, 0.97);
}

/* MAIN FOOTER */

.footer-main {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 100px;
  padding: 130px 8vw 90px;
}

.footer-eyebrow {
  margin: 0 0 25px;
  color: #e8d8ca;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.footer-heading h2 {
  margin: 0;
  color: #ffffff;
  font-family: "Cormorant Garamond", serif;
  font-size: clamp(3.5rem, 5vw, 5.5rem);
  font-weight: 500;
  line-height: 0.95;
}

.footer-heading h2 em {
  color: #e8d8ca;
  font-weight: 400;
}

/* DETAILS */

.footer-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.footer-column {
  padding-top: 20px;
  border-top: 1px solid rgba(232, 216, 202, 0.3);
}

.footer-column h3 {
  margin: 0 0 15px;
  color: #e8d8ca;
  font-family: "Cormorant Garamond", serif;
  font-size: 1.6rem;
  font-weight: 500;
}

.footer-column p {
  margin: 5px 0;
  color: #d8cec7;
  font-size: 0.8rem;
  line-height: 1.7;
}

.footer-column a {
  display: block;
  margin: 5px 0;
  color: #d8cec7;
  font-size: 0.8rem;
  line-height: 1.7;
  text-decoration: none;
  transition: color 0.25s ease;
}

.footer-column a:hover {
  color: #ffffff;
}

/* BOTTOM FOOTER */

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  margin: 0 8vw;
  padding: 35px 0;

  border-top: 1px solid rgba(232, 216, 202, 0.2);
}

/* BRAND */

.footer-brand {
  display: flex;
  flex-direction: column;
}

.footer-brand-main {
  font-family: "Cormorant Garamond", serif;
  font-size: 1.7rem;
  letter-spacing: 4px;
}

.footer-brand-sub {
  margin-top: 4px;
  color: #a98269;
  font-size: 0.5rem;
  font-weight: 500;
  letter-spacing: 3px;
}

/* SOCIAL MEDIA */

.social-links {
  display: flex;
  align-items: center;
  gap: 30px;
}

.social-links a {
  position: relative;

  color: #d8cec7;

  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 1.5px;

  text-decoration: none;
  text-transform: uppercase;

  transition: color 0.25s ease;
}

.social-links a:hover {
  color: #e8d8ca;
}

.social-links a::after {
  content: "";

  position: absolute;
  left: 0;
  bottom: -6px;

  width: 0;
  height: 1px;

  background: #a98269;

  transition: width 0.25s ease;
}

.social-links a:hover::after {
  width: 100%;
}

/* COPYRIGHT */

.copyright {
  margin: 0;
  color: #9f9189;
  font-size: 0.65rem;
  letter-spacing: 0.5px;
}

/* TABLET */

@media (max-width: 900px) {
  .footer-main {
    grid-template-columns: 1fr;
    gap: 60px;
  }

  .footer-bottom {
    flex-wrap: wrap;
  }
}

/* MOBILE */

@media (max-width: 600px) {
  .footer-main {
    padding: 90px 25px 60px;
  }

  .footer-details {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;

    margin: 0 25px;
    padding: 35px 0;
  }

  .social-links {
    flex-wrap: wrap;
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET,aAAa;EACb,eAAe;;EAEf,8CAA8C;AAChD;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;;EAErB,qBAAqB;EACrB,yBAAyB;;EAEzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,OAAO;EACP,YAAY;;EAEZ,QAAQ;EACR,WAAW;;EAEX,mBAAmB;;EAEnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;;AAEd;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,WAAW;;AAEX;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,WAAW;;AAEX;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;;IAEvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".footer {\n  color: #ffffff;\n  background: rgba(51, 40, 34, 0.97);\n}\n\n/* MAIN FOOTER */\n\n.footer-main {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 100px;\n  padding: 130px 8vw 90px;\n}\n\n.footer-eyebrow {\n  margin: 0 0 25px;\n  color: #e8d8ca;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n.footer-heading h2 {\n  margin: 0;\n  color: #ffffff;\n  font-family: \"Cormorant Garamond\", serif;\n  font-size: clamp(3.5rem, 5vw, 5.5rem);\n  font-weight: 500;\n  line-height: 0.95;\n}\n\n.footer-heading h2 em {\n  color: #e8d8ca;\n  font-weight: 400;\n}\n\n/* DETAILS */\n\n.footer-details {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n}\n\n.footer-column {\n  padding-top: 20px;\n  border-top: 1px solid rgba(232, 216, 202, 0.3);\n}\n\n.footer-column h3 {\n  margin: 0 0 15px;\n  color: #e8d8ca;\n  font-family: \"Cormorant Garamond\", serif;\n  font-size: 1.6rem;\n  font-weight: 500;\n}\n\n.footer-column p {\n  margin: 5px 0;\n  color: #d8cec7;\n  font-size: 0.8rem;\n  line-height: 1.7;\n}\n\n.footer-column a {\n  display: block;\n  margin: 5px 0;\n  color: #d8cec7;\n  font-size: 0.8rem;\n  line-height: 1.7;\n  text-decoration: none;\n  transition: color 0.25s ease;\n}\n\n.footer-column a:hover {\n  color: #ffffff;\n}\n\n/* BOTTOM FOOTER */\n\n.footer-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n\n  margin: 0 8vw;\n  padding: 35px 0;\n\n  border-top: 1px solid rgba(232, 216, 202, 0.2);\n}\n\n/* BRAND */\n\n.footer-brand {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-brand-main {\n  font-family: \"Cormorant Garamond\", serif;\n  font-size: 1.7rem;\n  letter-spacing: 4px;\n}\n\n.footer-brand-sub {\n  margin-top: 4px;\n  color: #a98269;\n  font-size: 0.5rem;\n  font-weight: 500;\n  letter-spacing: 3px;\n}\n\n/* SOCIAL MEDIA */\n\n.social-links {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.social-links a {\n  position: relative;\n\n  color: #d8cec7;\n\n  font-size: 0.65rem;\n  font-weight: 500;\n  letter-spacing: 1.5px;\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  transition: color 0.25s ease;\n}\n\n.social-links a:hover {\n  color: #e8d8ca;\n}\n\n.social-links a::after {\n  content: \"\";\n\n  position: absolute;\n  left: 0;\n  bottom: -6px;\n\n  width: 0;\n  height: 1px;\n\n  background: #a98269;\n\n  transition: width 0.25s ease;\n}\n\n.social-links a:hover::after {\n  width: 100%;\n}\n\n/* COPYRIGHT */\n\n.copyright {\n  margin: 0;\n  color: #9f9189;\n  font-size: 0.65rem;\n  letter-spacing: 0.5px;\n}\n\n/* TABLET */\n\n@media (max-width: 900px) {\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 60px;\n  }\n\n  .footer-bottom {\n    flex-wrap: wrap;\n  }\n}\n\n/* MOBILE */\n\n@media (max-width: 600px) {\n  .footer-main {\n    padding: 90px 25px 60px;\n  }\n\n  .footer-details {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n\n    margin: 0 25px;\n    padding: 35px 0;\n  }\n\n  .social-links {\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
